module.exports = __webpack_public_path__ + "img/dl3.56085910.png";